import axios from 'axios';

// Warn if environment variables are missing
if (!process.env.REACT_APP_API_URL) {
  console.warn('[API] REACT_APP_API_URL is not defined, falling back to "/api"');
}
if (!process.env.REACT_APP_CLIENT_URL) {
  console.warn('[API] REACT_APP_CLIENT_URL is not defined, falling back to "/" for redirects');
}

const API = axios.create({
  baseURL: process.env.REACT_APP_API_URL || '/api',
});

// 🔍 Request interceptor – log outgoing requests
API.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  
  // 📝 Log which request is being made
  // console.group(`[API] Request to ${config.url}`);
  // console.log('Token present:', !!token);
  
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
    // console.log('Token value:', token.substring(0, 20) + '...');
  }

  // Set Content-Type only if not FormData
  if (!(config.data instanceof FormData)) {
    config.headers['Content-Type'] = 'application/json';
  }

  // console.log('Headers:', config.headers);
  // console.groupEnd();

  return config;
});

// ⚠️ Response interceptor – handle errors like 401
API.interceptors.response.use(
  (response) => {
    // console.log(`[API] Response from ${response.config.url}`, response);
    return response;
  },
  (error) => {
    // console.error(`[API] Error from ${error.config?.url || 'unknown'}`, error);

    if (error.response?.status === 401) {
      // console.warn('[API] 401 Unauthorized – clearing token and redirecting to login');
      localStorage.removeItem('token');

      window.location.href = process.env.REACT_APP_CLIENT_URL
        ? `${process.env.REACT_APP_CLIENT_URL}/`
        : '/';
      return Promise.reject(new Error('Session expired. Please log in again.'));
    }

    return Promise.reject(error);
  }
);

export default API;